import style from "./home.module.css";
import { Link } from "react-router-dom";
import Movement from "./Movement";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Home - I Stand With The Forgotten Women</title>
        <meta
          name="description"
          content="Explore compassionate alternatives to abortion, empowering women with choices that safeguard life and mental well-being. Support matters."
        />
        <meta
          property="og:description"
          content="Explore compassionate alternatives to abortion, empowering women with choices that safeguard life and mental well-being. Support matters."
        />
        <meta
          name="keywords"
          content="Abortion alternatives,Conscience choice,Forgotten women,Psychological consequences,Unplanned pregnancies,Pregnancy support,Abortion regret,Community outreach,Advocacy and policy,Volunteer support"
        />
      </Helmet>

      <div className={`${style.videoContainer}`}>
        <video
          className="w-100"
          src="/Header.mp4"
          alt="banner"
          autoPlay
          muted
          loop
        />
        <div className={`${style.overlayContent} container `}>
          <div className={style.contentvideo}>
            <h1>
              Providing alternatives for those whose conscience dictates a
              different choice
            </h1>
            <h2>
              Their lives matter, <span>too!</span>
            </h2>

            <p className={style.contentPara}>
              Abortion rights are our country’s most divisive societal issue
              since the abolitionists took up the cause to abolish slavery.
              Regardless of ideologies, pro-life or pro-choice, I believe we owe
              it to ourselves to search for common ground. The common ground we
              all should be able to stand on is that women need to be provided
              with an alternative to abortion. We should all be able to agree
              that reducing the number of abortions is in the best interest of
              everyone. Not only in the best interest of the preborn but in the
              best interest of the mothers who carry them and the fathers who
              conceived them, and in the best interest of our shared humanity.
              If you agree, I invite you to stand with me.
            </p>
            <div className={style.homesocialicons}>
              <Link
                to="https://www.facebook.com/share/hUuQTv9TUqkxVtBM/?mibextid=LQQJ4d"
                className={style.footer_links}
                target="_blank"
              >
                {" "}
                <img src="/fbsvg.svg" alt="fb"></img>
              </Link>
              <br />

              <Link
                to="https://www.instagram.com/istandwithforgottenwomen/"
                className={style.footer_linksinsta}
                target="_blank"
              >
                {" "}
                <img src="/instasvg.svg" alt="insta"></img>
              </Link>
              <br />

              <Link
                to="https://x.com/4gottenwomen"
                className={style.footer_links}
                target="_blank"
              >
                {" "}
                <img src="/twitternew.png" alt="twitter"></img>
              </Link>
              <br />

              <Link
                to="https://www.youtube.com/@istandwiththeforgottenwomen"
                className={style.footer_links}
                target="_blank"
              >
                {" "}
                <img src="/youtube.png" alt="youtube"></img>
              </Link>
              <br />
            </div>
            <div className={`${style.donatebutton} mb-5`}>
              <Link to="/donate-to-us/">
                <button>Stand With Us</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Movement></Movement>
    </>
  );
};

export default Home;
